/* eslint-disable prefer-rest-params */
/* eslint-disable max-len */
import {LIVE_BASE_URL} from '../requestUrl/live'


/**
 * 直播间外业务请求封装
 */
class Http {
  constructor() {
    this.requestList = [] // 缓存请求接口
    this.isWxLoggingIn = false // 正在店铺登录
    this.isStoreLoggingIn = false // 正在店铺登录
    this.requestLimit = 0 // 请求次数限制
  }

  get(url, params, isNeedBiz = true, config = {}) {
    return this.request('get', url, params, isNeedBiz, config)
  }

  post(url, params, isNeedBiz = true, config = {}) {
    return this.request('post', url, params, isNeedBiz, config)
  }

  /**
 * @description 网络请求发送
 * @param {String} method 网络请求类型 get/post
 * @param {String} url 网络请求地址
 * @param {Object} params 请求传参
 * @param {Boolean} [isNeedBiz=true] 是否需要在传参外层用 bizData 变量包裹。例如：传参为{a: 1}，用bizData包裹后为{bizData: {a: 1}}
 * @param {Object} [config={}] 网络请求额外配置，如timeout
 */
  request(method, url, params = {}, isNeedBiz = true, config = {}) {
    const _params = arguments
    const that = this
    const koToken = wx.getStorageSync('koToken')
    const loginData = wx.getStorageSync('login_data')
    const appId = wx.getStorageSync('storeId') || ''
    if (method === 'get') {
      isNeedBiz = false
    }

    const requestParams = isNeedBiz ? {bizData: params} : params
    requestParams.token = loginData.token || ''

    let {header} = config
    header = header || {}
    header.app_id = appId
    header.Cookie = `ko_token=${koToken}`

    return new Promise(function (resolve, reject) {
      wx.request({
        url: LIVE_BASE_URL + url,
        method,
        data: JSON.stringify(requestParams),
        header,
        success(res) {
          if (res.statusCode === 200) {
            switch (res.data.code) {
              case 0: // 0 请求数据成功
                resolve(res)
                break
              case 10001: // token 失效
                that.requestList.push(() => resolve(that.request(..._params)))
                if (!that.isWxLoggingIn && that.requestLimit < 5) {
                  wx.showLoading({
                    title: '正在登录',
                  })
                  that.isWxLoggingIn = true
                  that.doWxLogin()
                  that.requestLimit++
                }
                break
              case 11302:
                that.requestList.push(() => resolve(that.request(..._params)))
                if (!that.isStoreLoggingIn && that.requestLimit < 5) {
                  that.isStoreLoggingIn = true
                  setTimeout(() => {
                    that.getKotoken(loginData.union_id)
                    that.requestLimit++
                  }, 2000)
                }
                break
              default: // 其他错误
                resolve(res)
                break
            }
          } else {
            // 请求接口失败
            reject(res)
          }
        },
        fail(err) {
          reject(err)
        }
      })
    })
  }

  /**
   * 小程序登录
   */
  doWxLogin() {
    const that = this
    wx.login({
      success(res) {
        if (res.code) {
          that.post('_alive/open/xe.alive.wechatapplet.login', {
            js_code: res.code
          }, false).then(res => {
            if (res.data.code === 0) {
              wx.setStorageSync('login_data', res.data.data)
              that.requestList.forEach(rq => rq())
              that.requestList = []
            }
            wx.hideLoading()
          }).catch(() => {})
        }
      }
    })
    this.isWxLoggingIn = false
  }


  /**
   * 直播间获取 ko_token
   */
  getKotoken() {
    const appId = wx.getStorageSync('storeId') || '' // 店铺id
    const unionId = wx.getStorageSync('unionId')
    this.post('_alive/open/xe.alive.wechatapplet.shop_ko_token_others', {
      app_id: appId,
      union_id: unionId
    }, false).then(res => {
      if (res.data.code === 0) {
        wx.hideLoading()
        wx.setStorageSync('koToken', res.data.data.ko_token)
        this.requestList.forEach(rq => rq())
        this.requestList = []
        this.isStoreLoggingIn = false
      } else {
        wx.hideLoading()
        wx.showToast({
          title: '接口异常-获取kotoken失败',
          icon: 'none'
        })
      }
      wx.hideLoading()
    }).catch(() => {
      wx.hideLoading()
      wx.showToast({
        title: '接口异常-获取kotoken失败',
        icon: 'none'
      })
    })
  }
}

export default new Http()
